
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
import { PropertiesDataV } from "@/types/tree";

import NiceButton from "@/components/UI/NiceButton.vue";
import { configStore, globalStore, uiStore } from "@/store/store-accessor";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import NotificationLogger from "@/lib/notifications/notifications";
import LoadingSpinner from "@/components/Reusable/LoadingSpinner.vue";
import { DesignProvider } from "@/types/design-library";

@Component({
  components: {
    Icon,
    NiceButton,
    LoadingSpinner
  }
})
export default class DesignLibraryGlobalSettings extends Vue {
  @Prop({ default: null })
  provider!: DesignProvider | null;

  @Prop({ default: null })
  lastImportedFromUrl!: string | null;

  loading = false;
  showImportScreen = false;

  toggleImportScreen() {
    this.showImportScreen = !this.showImportScreen;
  }

  async importSettings() {
    if (this.provider?.isLocal) return;

    this.loading = true;

    const url = this.provider?.url;

    const newSettings = pipe(
      await makeWordPressAjaxRequest({
        action: "breakdance_get_external_global_settings",
        decoder: PropertiesDataV,
        friendlyName: `Global Settings for "${url}"`,
        dataToPost: { url }
      }),
      fold(
        () => false,
        newSettings => {
          if (url) {
            configStore.setDesignLibrary({
              ...configStore.designLibrary,
              globalSettingsLastImportedFromUrl: url
            });
          }

          return newSettings && newSettings.globalSettings;
        }
      )
    );

    this.loading = false;
    this.showImportScreen = false;

    if (newSettings === false) {
      NotificationLogger.log.errorMessage(
        `Error importing Global Settings for "${
          this.provider?.name || this.provider?.url
        }"`
      );

      return;
    }

    globalStore.setGlobalSettings(newSettings);
    uiStore.setShouldPanelLoadFreshDataIntoStoreOnceOpened(
      "globalSettings",
      false
    );

    NotificationLogger.log.message(
      `Imported Global Settings from "${
        this.provider?.name || this.provider?.url
      }"`
    );
  }
}
